package io.horion.auth.presentation.ui.components.common

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.domain.models.AppLanguage
import io.horion.auth.domain.models.Language
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import org.jetbrains.compose.web.css.*

val LANGUAGES = listOf(
    Language("fr", "Français", "🇫🇷"),
    Language("en", "English",  "🇬🇧"),
)

@Composable
fun LanguageSelector() {
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)

    var selectedLang by remember {
        mutableStateOf(LANGUAGES.firstOrNull { it.code == AppLanguage.currentCode } ?: LANGUAGES[0])
    }
    var dropdownOpen by remember { mutableStateOf(false) }

    LaunchedEffect(AppLanguage.currentCode) {
        selectedLang = LANGUAGES.firstOrNull { it.code == AppLanguage.currentCode } ?: LANGUAGES[0]
    }

    Box(modifier = Modifier.position(Position.Relative)) {
        Row(
            modifier = Modifier
                .padding(leftRight = 12.px, topBottom = 8.px)
                .borderRadius(8.px)
                .border(1.px, LineStyle.Solid, colors.border)
                .backgroundColor(colors.inputBg)
                .cursor(Cursor.Pointer)
                .gap(8.px)
                .onClick { dropdownOpen = !dropdownOpen },
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(selectedLang.flag, modifier = Modifier.fontSize(16.px))
            SpanText(
                selectedLang.code.uppercase(),
                modifier = Modifier
                    .fontSize(AuthTypography.small)
                    .fontWeight(FontWeight.SemiBold)
                    .color(colors.onBackground)
            )
            SpanText(
                if (dropdownOpen) "▲" else "▼",
                modifier = Modifier.fontSize(10.px).color(colors.secondary)
            )
        }


        if (dropdownOpen) {
            Column(
                modifier = Modifier
                    .position(Position.Absolute)
                    .styleModifier {
                        property("top", "calc(100% + 4px)")
                        property("right", "0")
                        property("z-index", "200")
                    }
                    .borderRadius(8.px)
                    .border(1.px, LineStyle.Solid, colors.border)
                    .backgroundColor(colors.surface)
                    .styleModifier { property("box-shadow", "0 8px 24px rgba(0,0,0,0.15)") }
                    .padding(4.px)
            ) {
                LANGUAGES.forEach { lang ->
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(leftRight = 12.px, topBottom = 8.px)
                            .borderRadius(6.px)
                            .backgroundColor(
                                if (lang.code == selectedLang.code) colors.inputBg
                                else colors.surface
                            )
                            .cursor(Cursor.Pointer)
                            .gap(8.px)
                            .onClick {
                                AppLanguage.currentCode = lang.code
                                selectedLang = lang
                                dropdownOpen = false
                            },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText(lang.flag, modifier = Modifier.fontSize(16.px)
                            .fontFamily("Inter")
                        )
                        SpanText(
                            lang.label,
                            modifier = Modifier
                                .fontSize(AuthTypography.small)
                                .color(colors.onBackground)
                        )
                    }
                }
            }
        }
    }
}